import { useAppSelector } from 'libraries/redux'
import { useEffect } from 'react'
import { CategoriesSelectors } from 'store/category/selectors'

const FacebookMetaTag = () => {
  const data = useAppSelector(CategoriesSelectors.storeInfo)
  const verification = data?.data?.facebook_domain_verification

  useEffect(() => {
    if (verification) {
      const existingMeta = document.querySelector('meta[name="facebook-domain-verification"]')

      if (!existingMeta) {
        const meta = document.createElement('meta')
        meta.name = 'facebook-domain-verification'
        meta.content = verification
        document.head.insertBefore(meta, document.head.firstChild)
      } else {
        existingMeta.setAttribute('content', verification)
      }
    }
  }, [verification])

  return null
}

export default FacebookMetaTag
